import type {
  ApiEventId,
  ApiInternshipId,
  ApiJobId,
  ApiOrgId,
  ApiVolopId,
} from '#/api/types/ApiTypedId';
import {
  orgDashboardEditEventRoute,
  orgDashboardEditInternshipRoute,
  orgDashboardEditJobRoute,
  orgDashboardEditVolopRoute,
} from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { ListingType } from '#/types/ListingType';

type Args = {
  orgId: ApiOrgId;
  listingId: ApiJobId | ApiInternshipId | ApiVolopId | ApiEventId;
  listingType: Exclude<ListingType, 'ORG'>;
};

export function orgDashboardGetEditListingPathSwitch({
  orgId,
  listingId,
  listingType,
}: Args) {
  switch (listingType) {
    case 'JOB':
      return orgDashboardEditJobRoute.with({ orgId, jobId: listingId });
    case 'INTERNSHIP':
      return orgDashboardEditInternshipRoute.with({
        orgId,
        internshipId: listingId,
      });
    case 'VOLOP':
      return orgDashboardEditVolopRoute.with({
        orgId,
        volopId: listingId,
      });
    case 'EVENT':
      return orgDashboardEditEventRoute.with({
        orgId,
        eventId: listingId,
      });
  }
}
